import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    const token = localStorage.getItem('kaha_session');
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await axios.get(`${API}/auth/me`, { withCredentials: true, headers });
      setUser(res.data);
    } catch (err) {
      setUser(null);
      if (token) localStorage.removeItem('kaha_session');
    }
    setLoading(false);
  };

  useEffect(() => { checkAuth(); }, []);

  const login = (returnPath) => {
    if (returnPath && typeof returnPath === 'string') localStorage.setItem('kaha_auth_return', returnPath);
    const redirectUrl = window.location.origin + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    const token = localStorage.getItem('kaha_session');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true, headers });
    } catch (err) { console.warn('Logout error:', err.message); }
    localStorage.removeItem('kaha_session');
    setUser(null);
  };

  const refreshUser = () => checkAuth();

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
